import { Injectable } from '@angular/core';
import { CompartmentRuleListItem, CompartmentRuleListSearchCriteria } from '../../../models';
import { Store } from '@ngxs/store';
import { Observable, combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import {
  ListServerPaginationStateModel,
  LoadDataFacade,
  SetInitialStateFacade,
} from '../../../../../../../common/models';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../../../list-search-criteria';
import { CompartmentItemFacade } from '../../../../compartment/item/compartment-item.facade';
import { HubItemFacade } from '../../../../hub/item';
import {
  CompartmentRuleListDownloadStart,
  CompartmentRuleListInitialState,
  CompartmentRuleListLoad,
} from './compartment-rule-list.actions';
import { CompartmentRuleListState } from './compartment-rule-list.state';
import { MatDialogRef } from '@angular/material/dialog';
import { ExportDialogComponent } from '../../../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class CompartmentRuleListFacade implements LoadDataFacade, SetInitialStateFacade {
  ruleListDto$: Observable<ListServerPaginationStateModel<CompartmentRuleListItem>> = this.store.select(
    CompartmentRuleListState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(CompartmentRuleListState.getLoaded);

  constructor(
    private store: Store,
    private hubItemFacade: HubItemFacade,
    private compartmentItemFacade: CompartmentItemFacade,
    private listSearchCriteriaFacade: ListSearchCriteriaFacade,
  ) {}

  loadAll(): void {
    combineLatest([
      this.hubItemFacade.hubId$,
      this.compartmentItemFacade.compartmentId$,
      this.listSearchCriteriaFacade.getSearchCriteriaByListType(ListSearchCriteriaType.CompartmentRules),
    ])
      .pipe(take(1))
      .subscribe(([hubId, compartmentId, searchCriteria]: [number, number, CompartmentRuleListSearchCriteria]) => {
        this.loadAllWithInput(hubId, compartmentId, searchCriteria);
      });
  }

  loadAllWithInput(hubId: number, compartmentId: number, searchCriteria?: CompartmentRuleListSearchCriteria): void {
    this.store.dispatch(
      new CompartmentRuleListLoad({
        hubId,
        compartmentId,
        searchCriteria,
      }),
    );
  }

  startExportToFile(name: string, dialogRef: MatDialogRef<ExportDialogComponent>, navigationNeeded: boolean): void {
    combineLatest([
      this.hubItemFacade.hubId$,
      this.compartmentItemFacade.compartmentId$,
      this.listSearchCriteriaFacade.getSearchCriteriaByListType(ListSearchCriteriaType.CompartmentRules),
    ])
      .pipe(take(1))
      .subscribe(([hubId, compartmentId, searchCriteria]: [number, number, CompartmentRuleListSearchCriteria]) => {
        const { size: _size, page: _page, ...filterView } = searchCriteria;
        this.store.dispatch(
          new CompartmentRuleListDownloadStart({
            name,
            filterView,
            dialogRef,
            navigationNeeded,
            hubId,
            compartmentId,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new CompartmentRuleListInitialState());
  }
}
